function MainMenu(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	var menuVisible = false;
	var root;
	var menuToggle;
	var nav;
	var links;
	
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			root = $('html, body');
			nav = $('nav');
			menuToggle = $('.menu-toggle, .menu-close');
			
			// toggle button
			menuToggle.click(function(e) {
				e.preventDefault();
				if(!menuVisible){
					_this.show();
				} else {
					_this.hide();
				}
			});
			
			// menu items
			$('a', nav).click(function(e) {
				if(menuVisible){
					_this.hide();
				}
			});
			
			// keyboard controls
			$(document).keyup(function (e) {
				// watch for ESC key
				if (e.keyCode === 27 && menuVisible) {
					_this.hide();
				}
			});
			
			_this.inited = true;
		}
	};
	
	
	this.show = function(){
		nav.addClass('visible');
		root.addClass('no-scroll');

		// disable touch scroll
		_this.container[0].addEventListener('touchmove', function(e) {
			e.preventDefault();
		}, false);	
		
		menuVisible = true;
	};
		
	
	this.hide = function(){
		nav.removeClass('visible');
		root.removeClass('no-scroll');

		// enable touch scroll
		_this.container[0].removeEventListener('touchmove', function(e) {
			e.preventDefault();
		}, false);
		
		menuVisible = false;	
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
